import { render } from "./IndividualData.vue?vue&type=template&id=549df0d8&scoped=true"
import script from "./IndividualData.vue?vue&type=script&lang=js"
export * from "./IndividualData.vue?vue&type=script&lang=js"

import "./IndividualData.vue?vue&type=style&index=0&id=549df0d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549df0d8"]])

export default __exports__